import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { KzAccordionComponent } from '../../../../../../kz-ui/ui/accordion/kz-accordion.component';
import { KzIconsRegistryService } from '../../../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsInfos } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-infos.icon';
import { kzIconsCertified } from '../../../../../../kz-ui/ui/icon/generated-icons/kzIcons-certified.icon';
import { environment } from 'environments/environment';
import { SafeHtml } from "@angular/platform-browser";
import { StructuredDataService } from "../../../../../../shared/services/utilities/structured-data.service";

@Component({
  selector: 'app-pro-coaching-faq',
  templateUrl: './pro-coaching-faq.component.html',
  styleUrls: ['./pro-coaching-faq.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    StructuredDataService,
  ]
})
export class ProCoachingFaqComponent implements AfterViewInit {

  @Input() jobType: 'decorator' | 'architect' = 'decorator';

  @HostBinding('class.kz-pro-coaching-faq') class = true;

  public blogUrl = environment.BLOG_URL;

  @ViewChild('accordionComponent', {read: KzAccordionComponent, static: false}) accordionComponent: KzAccordionComponent;

  public jsonstructuredData: SafeHtml;

  @ViewChildren('questions') questions: QueryList<ElementRef>;
  @ViewChildren('responses') responses: QueryList<ElementRef>;

  constructor(
    private kzIconsRegistryService: KzIconsRegistryService,
    private readonly structuredDataService: StructuredDataService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsInfos, kzIconsCertified]);
  }

  ngAfterViewInit() {

    // Structured Data
    this.jsonstructuredData = this.structuredDataService.getJsonFAQFromComponents(
      this.questions.map((question) => question.nativeElement.innerHTML),
      this.responses.map((response) => response.nativeElement.innerHTML),
    );
    this.cdr.detectChanges();
  }

}
